import { spring, timeline } from "motion";

/**
 * Get current animating containers
 * container that is being removed and container that is being added
 *
 * @returns {{next: HTMLElement, prev: HTMLElement}}
 */
export function getAnimatingContainers() {
  const next = document.querySelector(
    ".main-content:not(.is-removing-container)",
  );

  const prev = document.querySelector(".main-content.is-removing-container");

  return { next, prev };
}

export function getAnimationSequenceToMorphBetweenElements(
  element,
  targetElement,
) {
  const e = element.getBoundingClientRect();
  const t = targetElement.getBoundingClientRect();
  return {
    transform: `translateX(${t.left - e.left}px) translateY(${
      t.top - e.top
    }px)`,
    width: `${t.width}px`,
    height: `${t.height}px`,
  };
}

export async function animateBackwards(prev, next) {
  // prepare leaving container
  prev.style.position = "absolute";
  prev.style.zIndex = "2";
  prev.style.top = "0";
  prev.style.left = "0";

  next.style.position = "relative";
  next.style.zIndex = "1";

  const springSettings = { stiffness: 150, damping: 40 };

  const sequence = [
    [
      prev,
      { transform: ["translateY(0%)", "translateY(100%)"] },
      {
        at: 0,
        easing: spring(springSettings),
      },
    ],
    [
      next,
      { transform: ["translateY(-10%)", "translateY(0%)"], opacity: [0, 1] },
      {
        at: 0.05,
        easing: spring(springSettings),
      },
    ],
  ];

  await timeline(sequence).finished;

  // reset next container
  prev.style.position = "";
  prev.style.zIndex = "";
  prev.style.top = "";
  prev.style.left = "";
}

export async function animateForward(prev, next) {
  // prepare leaving container
  prev.style.position = "relative";
  prev.style.zIndex = "1";

  next.style.position = "absolute";
  next.style.zIndex = "2";
  next.style.top = "0";
  next.style.left = "0";

  const springSettings = { stiffness: 150, damping: 40 };

  const sequence = [
    [
      prev,
      { transform: ["translateY(0)", "translateY(-20%)"], opacity: [1, 0] },
      {
        at: 0,
        easing: spring(springSettings),
      },
    ],
    [
      next,
      { transform: ["translateY(100%)", "translateY(0%)"] },
      {
        at: 0.05,
        easing: spring(springSettings),
      },
    ],
  ];

  await timeline(sequence).finished;

  // reset next container
  next.style.position = "";
  next.style.zIndex = "";
  next.style.top = "";
  next.style.left = "";
}
